<template>
  <div class="laypanel" style="margin-left: 40px;margin-right: 40px;">
    <el-tabs v-model="qdtab" style="height: 200px;" @tab-click="qbclick">
      <el-tab-pane label="渠道管理" name="qdgl">
        <el-tabs tab-position="right" :value="qdsubtab" @tab-click="subqbclick">
          <el-tab-pane label="传统渠道">
            <div>
              <el-row class="querypanel">
                <el-col :span="8">
                  <div class="leftpanel">
                    <div>传统渠道列表:</div>
                    <el-tree
                      class="filter-tree"
                      :data="qddata"
                      :props="qdprops"
                      default-expand-all
                      :expand-on-click-node="false"
                      :render-content="qdcontext">
                    </el-tree>
                    <div class="desinfo"> *定义不同的渠道等级与渠道和客户</div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="rightpanel">
                    <el-collapse v-model="qdlevelactive" accordion >
                      <el-collapse-item title="传统渠道名称" name="0">
                        <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                          <el-form-item label="传统渠道名称">
                            <el-input v-model="mycusname"></el-input>
                          </el-form-item>
                          <el-form-item label="新增一级渠道名称">
                            <el-input v-model="channelone" placeholder="仅新增一级子渠道时添加"></el-input>
                          </el-form-item>
                          <el-button @click="savechannelroot">修改并保存</el-button>
                          <el-button @click="addchannelone">新增一级渠道</el-button>
                        </el-form>
                      </el-collapse-item>
                      <el-collapse-item title="一级渠道" name="1">
                        <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                          <el-form-item label="当前一级渠道名称">
                            <el-input v-model="edchannelone"></el-input>
                          </el-form-item>
                          <el-form-item label="新增二级渠道名称">
                            <el-input v-model="channeltwo" placeholder="仅新增二级子渠道时添加"></el-input>
                          </el-form-item>

                            <el-button @click="savechangeone">修改并保存</el-button>
                            <el-button @click="addchanneltwo">新增二级渠道</el-button>

                        </el-form>
                      </el-collapse-item>
                      <el-collapse-item title="二级渠道" name="2">
                        <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                          <el-form-item label="当前二级渠道名称">
                            <el-input v-model="edchanneltwo"></el-input>
                          </el-form-item>
                          <el-form-item label="新增三级渠道名称">
                            <el-input v-model="channelthree" placeholder="仅新增三级子渠道时添加"></el-input>
                          </el-form-item>

                            <el-button @click="savechangetwo">修改并保存</el-button>
                            <el-button @click="addchannelthree">新增三级渠道</el-button>

                        </el-form>
                      </el-collapse-item>
                      <el-collapse-item title="三级渠道" name="3">
                        <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                          <el-form-item label="当前三级渠道名称">
                            <el-input v-model="edchannelthree"></el-input>
                          </el-form-item>

                            <el-button @click="savechangethree">修改并保存</el-button>

                        </el-form>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">

                <el-col :span="10"><div class="queryinput">
                  <el-input v-model="channelpercent" placeholder="请输入分成比率"></el-input>
                </div></el-col>
                <el-col :span="4">
                  <div>
                    <el-button @click="addchannelpercent">保存分成比率</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24" class="querybtn">
                  <div class="subquerypanel"> 当前所选渠道名称： {{curchannelname}}</div>
                </el-col>

                <el-col :span="10"><div class="queryinput">
                  <el-input v-model="query_cc_cusname" placeholder="请输入客户名称"></el-input>
                </div></el-col>
                <el-col :span="10"><div class="queryinput">
                  <el-input v-model="query_cc_cusno" placeholder="请输入营业执照号"></el-input>
                </div></el-col>
                <el-col :span="4">
                  <div>
                    <el-button @click="querycccus">查询</el-button>
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 15px;">
                <el-col :span="18"><div >
                  <el-transfer
                    filterable
                    :titles="['查询客户列表', '待选列表']"
                    v-model="cus_rightdata"
                    :data="cus_leftdata"
                    :props="{
                    key: 'id',
                    label: 'name'
                    }"
                  >
                  </el-transfer>
                </div>
                </el-col>
                <el-col :span="6">
                  <div class="centerbtn">
                    <el-button @click="savecustochannel">>保存至渠道></el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24">
                  <el-table
                    stripe
                    :data="myqdcusdatabase"
                    style="width: 100%"
                    ref="multipleTable">
                    <el-table-column
                      min-width="15%"
                      prop="cid"
                      label="渠道编号"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      min-width="35%"
                      label="渠道名称">
                    </el-table-column>
                    <el-table-column
                      prop="cusname"
                      min-width="35%"
                      label="客户名称">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      min-width="15%"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="移除该客户" placement="top-start">
                          <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removeqdcus(scope.$index, myqdcusdatabase)"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="分销渠道">
            <el-row class="querypanel">
              <el-col :span="12">
                <el-form   label-width="140px" label-position="left">
                  <el-form-item label="分销等级选择:">
                    <el-select v-model="fxlevel" filterable placeholder="请选择分销等级" @change="fxchange">
                      <el-option
                        v-for="item in fxlevellist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="12">
                <el-form   label-width="140px" label-position="left">
                  <el-form-item label="分成比率:">
                    <el-input v-model="fxpercent" placeholder="请输入分成比率"></el-input>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="24">
                <div>
                  <el-button @click="addfxpercent">保存分成比率</el-button>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="销售区域(人员)配置" name="qdqy">
        <div>
          <el-row class="querypanel">
            <el-col :span="8">
              <div class="leftpanel">
                <div>传统渠道列表:</div>
                <el-tree
                  class="filter-tree"
                  :data="qddata"
                  :props="qdprops"
                  default-expand-all
                  :expand-on-click-node="false"
                  :render-content="qdrycontext">
                </el-tree>
                <div class="desinfo"> *定义不同的渠道等级与渠道和客户</div>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="rightpanel">
                <el-table
                  stripe
                  :data="myqdcusdata"
                  ref="multipleTable">
                  <el-table-column
                    min-width="30px"
                    prop="cid"
                    label="渠道编号"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="渠道名称">
                  </el-table-column>
                  <el-table-column
                    prop="cusname"
                    label="客户名称">
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="80px"
                  >
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="选择该渠道客户" placement="top-start">
                        <i class="fa fa-pencil-square-o fa-lg curpointer" v-on:click="selectqdcus(scope.$index, myqdcusdata)"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-col :span="6">
              <div class="leftpanel">
                <div>可销售区域:</div>
                <el-tree
                  class="filter-tree"
                  ref="areatree"
                  :data="qdareadata"
                  :props="qdareaprops"
                  default-expand-all
                  :expand-on-click-node="false"
                  :render-content="qdareacontent">
                </el-tree>
                <div class="desinfo"> *定义渠道可销售区域</div>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="rightpanel">
                <el-collapse v-model="qdareaactive" accordion >
                  <el-collapse-item title="区域总称" name="0">
                    <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                      <el-form-item label="当前区域总称">
                        <el-input v-model="myareaname"></el-input>
                      </el-form-item>
                      <el-form-item label="新增一级区域名称">
                        <el-input v-model="areaone" placeholder="仅新增一级子区域时添加"></el-input>
                      </el-form-item>
                      <el-button @click="savearearoot">修改并保存</el-button>
                      <el-button @click="addareaone">新增一级区域</el-button>
                    </el-form>
                  </el-collapse-item>
                  <el-collapse-item title="一级区域" name="1">
                    <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                      <el-form-item label="当前一级区域名称">
                        <el-input v-model="edareaone"></el-input>
                      </el-form-item>
                      <el-form-item label="一级区域负责人">
                        <el-select v-model="fzrone" filterable placeholder="请选择区域负责人">
                          <el-option
                            v-for="item in fzrlist"
                            :key="item.id.Int64"
                            :label="item.name.String"
                            :value="item.id.Int64"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="新增二级区域名称">
                        <el-input v-model="areatwo" placeholder="仅新增二级子区域时添加"></el-input>
                      </el-form-item>
                        <el-button @click="saveareaone">修改并保存</el-button>
                        <el-button @click="addareatwo">新增二级区域</el-button>

                    </el-form>
                  </el-collapse-item>
                  <el-collapse-item title="二级区域" name="2">
                    <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                      <el-form-item label="当前二级区域名称">
                        <el-input v-model="edareatwo"></el-input>
                      </el-form-item>
                      <el-form-item label="二级区域负责人">
                        <el-select v-model="fzrtwo" filterable placeholder="请选择区域负责人" >
                          <el-option
                            v-for="item in fzrlist"
                            :key="item.id.Int64"
                            :label="item.name.String"
                            :value="item.id.Int64"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="新增三级区域名称">
                        <el-input v-model="areathree" placeholder="仅新增三级子区域时添加"></el-input>
                      </el-form-item>
                        <el-button @click="saveareatwo">修改并保存</el-button>
                        <el-button @click="addareathree">新增三级区域</el-button>

                    </el-form>
                  </el-collapse-item>
                  <el-collapse-item title="三级区域" name="3">
                    <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                      <el-form-item label="当前三级区域名称">
                        <el-input v-model="edareathree"></el-input>
                      </el-form-item>
                      <el-form-item label="三级区域负责人">
                        <el-select v-model="fzrthree" filterable placeholder="请选择区域负责人">
                          <el-option
                            v-for="item in fzrlist"
                            :key="item.id.Int64"
                            :label="item.name.String"
                            :value="item.id.Int64"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                        <el-button @click="saveareathree">修改并保存</el-button>

                    </el-form>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-col :span="8">
              <div class="subquerypanel"> 所选渠道客户： {{curqdcusname}}</div>
              <div class="subquerypanel"> 所选区域： {{curareaname}}</div>
              <div class="subquerypanel"> 所选区域负责人： {{curfzrname}}</div>
              <el-button @click="savechannelset">数据绑定</el-button>
            </el-col>
            <el-col :span="16">
              <el-table
                stripe
                :data="mycusareadata"
                ref="multipleTable">
                <el-table-column
                  prop="cusername.String"
                  label="渠道客户名称">
                </el-table-column>
                <el-table-column
                  prop="areaname.String"
                  label="区域名称">
                </el-table-column>
                <el-table-column
                  prop="username.String"
                  label="负责人">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="移除该区域" placement="top-start">
                      <i class="fa fa-trash-o fa-lg curpointer" v-on:click="removecusarea(scope.$index, mycusareadata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'ChannelControl',
  data () {
    return {
      fxlevellist: [{
        value: '1',
        label: '一级分销'
      }, {
        value: '2',
        label: '二级分销'
      }],
      fxlevel: '',
      fxpercent: '',
      channellevel: '',
      channelpercent: '',
      levelpercentid: '',
      curchannelname: '',
      curqdcusname: '',
      curqdcurdata: '',
      curareaname: '',
      curareadata: '',
      myqdcusdatabase: [],
      curfzrname: '',
      curfzrdata: '',
      qdlevelactive: [],
      fxqdlevelactive: [],
      qdareaactive: [],
      mycusareadata: [],
      fzrlist: [],
      fzrone: '',
      fzrtwo: '',
      fzrthree: '',
      mycusname: '',
      myfxcusname: '',
      myareaname: '',
      qdselect: [],
      qdselectnode: [],
      fxqdselect: [],
      fxqdselectnode: [],
      qdareaselect: [],
      qdareaselectnode: [],
      channelone: '',
      channeltwo: '',
      channelthree: '',
      edchannelone: '',
      edchanneltwo: '',
      edchannelthree: '',
      areaone: '',
      areatwo: '',
      areathree: '',
      edareaone: '',
      edareatwo: '',
      edareathree: '',
      channelpercentid: '',
      fxchannelone: '',
      fxchanneltwo: '',
      edfxchannelone: '',
      edfxchanneltwo: '',
      myqdcusdata: [],
      qddata: [],
      qdkhshowdata: [],
      fxqddata: [],
      area_userdata: [],
      cusinfo: '',
      cuslist: '',
      cus_rightdata: [],
      cus_leftdata: [],
      query_cc_cusname: '',
      query_cc_cusno: '',
      qdtab: 'qdgl',
      qdsubtab: 0,
      qdprops: {
        children: 'Children',
        label: 'name'
      },
      fxqdprops: {
        children: 'Children',
        label: 'name'
      },
      qdareadata: [],
      qdareaprops: {
        children: 'Children',
        label: 'name'
      }
    }
  },
  mounted: function () {
    that = this
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      console.log('channelcontrol mounted')
      if ((this.qdtab === 'qdgl' || this.qdtab === 'qdqy') && this.qdsubtab === 0) {
        console.log('初始化渠道信息')
        var ctqdtreetmp = localStorage.getItem('ctqdtree')
        if (ctqdtreetmp === null) {
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/gctree',
            method: 'post',
            data: {
              cusid: {Int64: parseInt(v), Valid: true},
              parentid: {Int64: -1, Valid: true},
              type: {Int64: 0, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log('获取渠道列表')
              if (res.data.success) {
                console.log(res.data.data === '[]')
                if (res.data.data === '[]') {
                  console.log('空数据，考虑增加一个根节点')
                  var cusname = getCookie('CusName')
                  console.log(cusname)
                  var addrootdata = {
                    cusid: {Int64: parseInt(that.khid), Valid: true},
                    name: {String: cusname, Valid: true},
                    type: {Int64: parseInt(0), Valid: true},
                    level: {Int64: parseInt(0), Valid: true},
                    haschild: {Int64: parseInt(0), Valid: true},
                    parentid: {Int64: parseInt(-1), Valid: true}
                  }
                  that.$http({
                    url: 'https://api.sqnetsoft.cn/control/caau',
                    method: 'post',
                    data: addrootdata,
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  })
                    .then(function (res) {
                      console.log(res)
                      if (res.data.success) {
                        that.$http({
                          url: 'https://api.sqnetsoft.cn/control/gctree',
                          method: 'post',
                          data: {
                            cusid: {Int64: parseInt(that.khid), Valid: true},
                            type: {Int64: 0, Valid: true},
                            parentid: {Int64: -1, Valid: true}
                          },
                          headers: {
                            'Content-Type': 'application/json'
                          }
                        })
                          .then(function (res) {
                            console.log('获取渠道列表')
                            if (res.data.success) {
                              console.log('获取到正常数据')
                              that.qddata = JSON.parse(res.data.data)
                              localStorage.setItem('ctqdtree', res.data.data)
                            } else {
                            }
                          })
                          .catch(function (error) {
                            console.log('error' + error)
                          })
                      }
                    })
                    .catch(function (error) {
                      console.log('error' + error)
                    })
                } else {
                  console.log('获取到正常数据')
                  that.qddata = JSON.parse(res.data.data)
                  localStorage.setItem('ctqdtree', res.data.data)
                  console.log(that.qddata)
                }
              } else {
                console.log('空数据，考虑增加一个根节点')
                var cusname1 = getCookie('CusName')
                console.log(cusname1)
                var addrootdata1 = {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  name: {String: cusname1, Valid: true},
                  type: {Int64: parseInt(0), Valid: true},
                  level: {Int64: parseInt(0), Valid: true},
                  haschild: {Int64: parseInt(0), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true}
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/control/caau',
                  method: 'post',
                  data: addrootdata1,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.success) {
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/control/gctree',
                        method: 'post',
                        data: {
                          cusid: {Int64: parseInt(that.khid), Valid: true},
                          type: {Int64: 0, Valid: true},
                          parentid: {Int64: -1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          console.log('获取渠道列表')
                          if (res.data.success) {
                            console.log('获取到正常数据')
                            that.qddata = JSON.parse(res.data.data)
                            localStorage.setItem('ctqdtree', res.data.data)
                          } else {
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.qddata = JSON.parse(ctqdtreetmp)
        }
        var qdareatreetmp = localStorage.getItem('qdareatree')
        if (qdareatreetmp === null) {
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/gcatree',
            method: 'post',
            data: {
              cusid: {Int64: parseInt(that.khid), Valid: true},
              parentid: {Int64: -1, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('获取到正常数据')
                if (res.data.data === '[]') {
                  console.log('空数据，考虑增加一个根节点')
                  var addrootareadata = {
                    cusid: {Int64: parseInt(that.khid), Valid: true},
                    name: {String: '所有区域', Valid: true},
                    level: {Int64: parseInt(0), Valid: true},
                    haschild: {Int64: parseInt(0), Valid: true},
                    parentid: {Int64: parseInt(-1), Valid: true},
                    userid: {Int64: parseInt(-1), Valid: true}
                  }
                  that.$http({
                    url: 'https://api.sqnetsoft.cn/control/caaau',
                    method: 'post',
                    data: addrootareadata,
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  })
                    .then(function (res) {
                      console.log(res)
                      if (res.data.success) {
                        that.$http({
                          url: 'https://api.sqnetsoft.cn/control/gcatree',
                          method: 'post',
                          data: {
                            cusid: {Int64: parseInt(that.khid), Valid: true},
                            parentid: {Int64: -1, Valid: true}
                          },
                          headers: {
                            'Content-Type': 'application/json'
                          }
                        })
                          .then(function (res) {
                            console.log('获取渠道列表')
                            if (res.data.success) {
                              console.log('获取到正常数据')
                              that.qdareadata = JSON.parse(res.data.data)
                              localStorage.setItem('qdareatree', res.data.data)
                            } else {
                            }
                          })
                          .catch(function (error) {
                            console.log('error' + error)
                          })
                      }
                    })
                    .catch(function (error) {
                      console.log('error' + error)
                    })
                } else {
                  that.qdareadata = JSON.parse(res.data.data)
                  localStorage.setItem('qdareatree', res.data.data)
                  console.log(that.qdareadata)
                }
              } else {
                console.log('空数据，考虑增加一个根节点')
                var addrootareadata1 = {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  name: {String: '所有区域', Valid: true},
                  level: {Int64: parseInt(0), Valid: true},
                  haschild: {Int64: parseInt(0), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true},
                  userid: {Int64: parseInt(-1), Valid: true}
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/control/caaau',
                  method: 'post',
                  data: addrootareadata1,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.success) {
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/control/gcatree',
                        method: 'post',
                        data: {
                          cusid: {Int64: parseInt(that.khid), Valid: true},
                          parentid: {Int64: -1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          console.log('获取渠道列表')
                          if (res.data.success) {
                            console.log('获取到正常数据')
                            that.qdareadata = JSON.parse(res.data.data)
                            localStorage.setItem('qdareatree', res.data.data)
                          } else {
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.qdareadata = JSON.parse(qdareatreetmp)
        }
        var cususertmp = localStorage.getItem('cususer')
        if (cususertmp === null) {
          var sqlstr = 'cus_id = ' + this.khid
          that.$http({
            url: 'https://api.sqnetsoft.cn/customer/getcususer',
            method: 'post',
            data: {
              whereinfo: {String: sqlstr, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              console.log(JSON.parse(res.data.data))
              if (res.data.success) {
                that.fzrlist = JSON.parse(res.data.data)
                localStorage.setItem('cususer', res.data.data)
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.fzrlist = JSON.parse(cususertmp)
        }
      } else if (this.qdtab === 'qdgl' && this.qdsubtab === 1) {
        console.log('初始化分销渠道信息')
        var fxqdtreetmp = localStorage.getItem('fxqdtree')
        if (fxqdtreetmp === null) {
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/gctree',
            method: 'post',
            data: {
              cusid: {Int64: parseInt(v), Valid: true},
              parentid: {Int64: -1, Valid: true},
              type: {Int64: 1, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log('获取渠道列表')
              if (res.data.success) {
                console.log('获取到正常数据')
                that.fxqddata = JSON.parse(res.data.data)
                localStorage.setItem('fxqdtree', res.data.data)
                console.log(that.qddata)
              } else {
                var cusname = getCookie('CusName')
                console.log(cusname)
                var addrootdata = {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  name: {String: cusname, Valid: true},
                  type: {Int64: parseInt(1), Valid: true},
                  level: {Int64: parseInt(0), Valid: true},
                  haschild: {Int64: parseInt(0), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true}
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/control/caau',
                  method: 'post',
                  data: addrootdata,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.success) {
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/control/gctree',
                        method: 'post',
                        data: {
                          cusid: {Int64: parseInt(that.khid), Valid: true},
                          type: {Int64: 1, Valid: true},
                          parentid: {Int64: -1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          console.log('获取渠道列表')
                          if (res.data.success) {
                            console.log('获取到正常数据')
                            that.fxqddata = JSON.parse(res.data.data)
                            localStorage.setItem('fxqdtree', res.data.data)
                          } else {
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.fxqddata = JSON.parse(fxqdtreetmp)
        }
      }
    }
    setTimeout(function () {
      that.$parent.$children[0].$refs.headmenu.activeIndex = getCookie('SelectMainMenuID')
    }, 200)
  },
  methods: {
    qdcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.qd_edit(node, data)}> </i>
            <i class="fa fa-trash-o opicon" on-click={ () => this.qd_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    qdrycontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.qdry_edit(node, data)}> </i>
            <i class="fa fa-trash-o opicon" on-click={ () => this.qdry_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    qdareacontent (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.qdarea_edit(node, data)}> </i>
            <i class="fa fa-trash-o opicon" on-click={ () => this.qdarea_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    qd_edit (node, data) {
      this.qdselect = data
      console.log(data)
      this.qdselectnode = node
      console.log(this.qdselectnode)
      that.qdlevelactive = [data.level.toString()]
      console.log(data.level)
      this.curchannelname = data.name
      switch (data.level) {
        case 0: {
          that.mycusname = data.name
          that.channelone = ''
          that.channeltwo = ''
          that.channelthree = ''
          that.edchannelone = ''
          that.edchanneltwo = ''
          that.edchannelthree = ''
          break
        }
        case 1: {
          that.edchannelone = data.name
          that.channeltwo = ''
          that.channelthree = ''
          that.channelone = ''
          that.edchanneltwo = ''
          that.edchannelthree = ''
          that.mycusname = ''
          break
        }
        case 2: {
          that.edchanneltwo = data.name
          that.channelthree = ''
          that.edchannelone = ''
          that.channeltwo = ''
          that.edchannelthree = ''
          that.mycusname = ''
          that.channelone = ''
          break
        }
        case 3: {
          that.edchannelthree = data.name
          that.edchannelone = ''
          that.edchanneltwo = ''
          that.channelthree = ''
          that.mycusname = ''
          that.channelone = ''
          that.channeltwo = ''
          break
        }
      }
      var idstr = 'cusid = ' + that.khid + ' and c_id=' + parseInt(that.qdselect.id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/ccquery',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.myqdcusdatabase = JSON.parse(res.data.data)
            that.cus_rightdata = []
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      var idstr1 = 'cusid = ' + that.khid + ' and c_id=' + parseInt(that.qdselect.id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/gbcp',
        method: 'post',
        data: {
          whereinfo: {'String': idstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            if (res.data.data !== '[]') {
              var data = JSON.parse(res.data.data)
              if (data[0].channelpercent) {
                that.channelpercentid = data[0].id.Int64
                that.channelpercent = data[0].channelpercent.String
              } else {
                that.channelpercent = ''
              }
            } else {
              that.channelpercent = ''
            }
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    qd_remove (node, data) {
      console.log(data)
      if (data.level === 0) {
        that.$message({
          type: 'info',
          message: '请不要删除总渠道名称'
        })
      } else {
        var idlist = []
        if (data.haschild === 0) {
          idlist.push(data.id)
        } else {
          idlist.push(data.id)
          var cnode = data.Children
          for (var index in cnode) {
            console.log(cnode[index])
            idlist.push(cnode[index].id)
            if (cnode[index].haschild === 0) {
            } else {
              var cinode = cnode[index].Children
              for (var i in cinode) {
                idlist.push(cinode[i].id)
                if (cinode[i].haschild === 0) {
                } else {
                  var ciinode = cinode[i].Children
                  for (var j in ciinode.Children) {
                    idlist.push(ciinode.Children[j].id)
                    if (cinode[i].haschild === 0) {
                    } else {
                      for (var k in ciinode.Children) {
                        idlist.push(ciinode.Children[k].id)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        var idstr = 'id in (' + idlist + ')'
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/cdel',
          method: 'post',
          data: {
            whereinfo: {String: idstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.$http({
                url: 'https://api.sqnetsoft.cn/control/gctree',
                method: 'post',
                data: {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  type: {Int64: 0, Valid: true},
                  parentid: {Int64: -1, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log('获取渠道列表')
                  if (res.data.success) {
                    console.log('获取到正常数据')
                    that.qddata = JSON.parse(res.data.data)
                    localStorage.setItem('ctqdtree', res.data.data)
                    console.log(that.qddata)
                  } else {
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    qdry_edit (node, data) {
      this.qdselect = data
      var idstr = 'cusid = ' + that.khid + ' and c_id=' + parseInt(that.qdselect.id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/ccquery',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.myqdcusdata = JSON.parse(res.data.data)
            that.cus_rightdata = []
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    qdarea_edit (node, data) {
      console.log('qdarea edit')
      console.log(data)
      this.qdareaselect = data
      this.qdareaselectnode = node
      that.qdareaactive = [data.level.toString()]
      this.curareaname = data.name
      this.curareadata = data
      console.log(this.fzrlist)
      var usertmp = data.userid
      if (usertmp > 0) {
        usertmp = data.userid
      } else {
        usertmp = ''
      }
      switch (data.level) {
        case 0: {
          that.myareaname = data.name
          that.areaone = ''
          that.areatwo = ''
          that.areathree = ''
          that.edareaone = ''
          that.edareatwo = ''
          that.edareathree = ''
          break
        }
        case 1: {
          that.edareaone = data.name
          that.areatwo = ''
          that.areathree = ''
          that.areaone = ''
          that.edareatwo = ''
          that.fzrone = usertmp
          that.edareathree = ''
          that.myareaname = ''
          break
        }
        case 2: {
          that.edareatwo = data.name
          that.areathree = ''
          that.edareaone = ''
          that.areatwo = ''
          that.edareathree = ''
          that.fzrtwo = usertmp
          that.myareaname = ''
          that.areaone = ''
          break
        }
        case 3: {
          that.edareathree = data.name
          that.fzrthree = usertmp
          that.edareaone = ''
          that.edareatwo = ''
          that.areathree = ''
          that.myareaname = ''
          that.areaone = ''
          that.areatwo = ''
          break
        }
      }
      var dataindex = this.fzrlist.findIndex(d => d.id.Int64 === data.userid)
      console.log(dataindex)
      if (dataindex < 0) {
        this.curfzrdata = ''
        this.curfzrname = ''
      } else {
        this.curfzrdata = this.fzrlist[dataindex]
        this.curfzrname = this.fzrlist[dataindex].name.String
      }
    },
    qdarea_remove (node, data) {
      if (data.level === 0) {
        that.$message({
          type: 'info',
          message: '请不要删除总渠道名称'
        })
      } else {
        var idlist = []
        if (data.haschild === 0) {
          idlist.push(data.id)
        } else {
          idlist.push(data.id)
          var cnode = data.Children
          for (var index in cnode) {
            console.log(cnode[index])
            idlist.push(cnode[index].id)
            if (cnode[index].haschild === 0) {
            } else {
              var cinode = cnode[index].Children
              for (var i in cinode) {
                idlist.push(cinode[i].id)
                if (cinode[i].haschild === 0) {
                } else {
                  var ciinode = cinode[i].Children
                  for (var j in ciinode.Children) {
                    idlist.push(ciinode.Children[j].id)
                    if (cinode[i].haschild === 0) {
                    } else {
                      for (var k in ciinode.Children) {
                        idlist.push(ciinode.Children[k].id)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        var idstr = 'id in (' + idlist + ')'
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/cadel',
          method: 'post',
          data: {
            whereinfo: {String: idstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.$http({
                url: 'https://api.sqnetsoft.cn/control/gcatree',
                method: 'post',
                data: {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  parentid: {Int64: -1, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log('获取渠道列表')
                  if (res.data.success) {
                    console.log('获取到正常数据')
                    that.qdareadata = JSON.parse(res.data.data)
                    localStorage.setItem('qdareatree', res.data.data)
                  } else {
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    qbclick (tab, event) {
      console.log('qbclick')
      console.log(tab, event)
      if (tab.index === '1') {
        console.log('初始化区域信息')
        var qdareatreetmp = localStorage.getItem('qdareatree')
        if (qdareatreetmp === null) {
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/gcatree',
            method: 'post',
            data: {
              cusid: {Int64: parseInt(that.khid), Valid: true},
              parentid: {Int64: -1, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('获取到正常数据')
                that.qdareadata = JSON.parse(res.data.data)
                localStorage.setItem('qdareatree', res.data.data)
                console.log(that.qdareadata)
              } else {
                console.log('空数据，考虑增加一个根节点')
                var addrootareadata = {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  name: {String: '所有区域', Valid: true},
                  level: {Int64: parseInt(0), Valid: true},
                  haschild: {Int64: parseInt(0), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true},
                  userid: {Int64: parseInt(-1), Valid: true}
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/control/caaau',
                  method: 'post',
                  data: addrootareadata,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.success) {
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/control/gcatree',
                        method: 'post',
                        data: {
                          cusid: {Int64: parseInt(that.khid), Valid: true},
                          parentid: {Int64: -1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          console.log('获取渠道列表')
                          if (res.data.success) {
                            console.log('获取到正常数据')
                            that.qdareadata = JSON.parse(res.data.data)
                            localStorage.setItem('qdareatree', res.data.data)
                          } else {
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.qdareadata = JSON.parse(qdareatreetmp)
        }
        var cususertmp = localStorage.getItem('cususer')
        if (cususertmp === null) {
          var sqlstr = 'cus_id = ' + this.khid
          that.$http({
            url: 'https://api.sqnetsoft.cn/customer/getcususer',
            method: 'post',
            data: {
              whereinfo: {String: sqlstr, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              console.log(JSON.parse(res.data.data))
              if (res.data.success) {
                that.fzrlist = JSON.parse(res.data.data)
                localStorage.setItem('cususer', res.data.data)
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.fzrlist = JSON.parse(cususertmp)
        }
      }
    },
    subqbclick (tab, event) {
      console.log(tab.index)
      if (tab.index === '0') {
        console.log('初始化渠道信息')
        var ctqdtreetmp = localStorage.getItem('ctqdtree')
        if (ctqdtreetmp === null) {
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/gctree',
            method: 'post',
            data: {
              cusid: {Int64: parseInt(that.khid), Valid: true},
              parentid: {Int64: -1, Valid: true},
              type: {Int64: 0, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log('获取渠道列表')
              if (res.data.success) {
                console.log('获取到正常数据')
                that.qddata = JSON.parse(res.data.data)
                localStorage.setItem('ctqdtree', res.data.data)
                console.log(that.qddata)
              } else {
                console.log('空数据，考虑增加一个根节点')
                var cusname = getCookie('CusName')
                console.log(cusname)
                var addrootdata = {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  name: {String: cusname, Valid: true},
                  type: {Int64: parseInt(0), Valid: true},
                  level: {Int64: parseInt(0), Valid: true},
                  haschild: {Int64: parseInt(0), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true}
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/control/caau',
                  method: 'post',
                  data: addrootdata,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.success) {
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/control/gctree',
                        method: 'post',
                        data: {
                          cusid: {Int64: parseInt(that.khid), Valid: true},
                          type: {Int64: 0, Valid: true},
                          parentid: {Int64: -1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          console.log('获取渠道列表')
                          if (res.data.success) {
                            console.log('获取到正常数据')
                            that.qddata = JSON.parse(res.data.data)
                            localStorage.setItem('ctqdtree', res.data.data)
                          } else {
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.qddata = JSON.parse(ctqdtreetmp)
        }
      } else if (tab.index === '1') {
        console.log('初始化分销渠道信息')
        var fxqdtreetmp = localStorage.getItem('fxqdtree')
        if (fxqdtreetmp === null) {
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/gctree',
            method: 'post',
            data: {
              cusid: {Int64: parseInt(that.khid), Valid: true},
              parentid: {Int64: -1, Valid: true},
              type: {Int64: 1, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log('获取渠道列表')
              if (res.data.success) {
                console.log('获取到正常数据')
                that.fxqddata = JSON.parse(res.data.data)
                localStorage.setItem('fxqdtree', res.data.data)
                console.log(that.qddata)
              } else {
                var cusname = getCookie('CusName')
                console.log(cusname)
                var addrootdata = {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  name: {String: cusname, Valid: true},
                  type: {Int64: parseInt(1), Valid: true},
                  level: {Int64: parseInt(0), Valid: true},
                  haschild: {Int64: parseInt(0), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true}
                }
                that.$http({
                  url: 'https://api.sqnetsoft.cn/control/caau',
                  method: 'post',
                  data: addrootdata,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then(function (res) {
                    console.log(res)
                    if (res.data.success) {
                      that.$http({
                        url: 'https://api.sqnetsoft.cn/control/gctree',
                        method: 'post',
                        data: {
                          cusid: {Int64: parseInt(that.khid), Valid: true},
                          type: {Int64: 1, Valid: true},
                          parentid: {Int64: -1, Valid: true}
                        },
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      })
                        .then(function (res) {
                          console.log('获取渠道列表')
                          if (res.data.success) {
                            console.log('获取到正常数据')
                            that.fxqddata = JSON.parse(res.data.data)
                            localStorage.setItem('fxqdtree', res.data.data)
                          } else {
                          }
                        })
                        .catch(function (error) {
                          console.log('error' + error)
                        })
                    }
                  })
                  .catch(function (error) {
                    console.log('error' + error)
                  })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.fxqddata = JSON.parse(fxqdtreetmp)
        }
      }
    },
    savechannelroot () {
      console.log(that.qdselect)
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 0) {
          var savedata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.mycusname, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdselectnode.data.name = that.mycusname
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                console.log(that.qddata)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savefxchannelroot () {
      console.log(that.fxqdselect)
      if (that.fxqdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.fxqdselectnode.data.level === 0) {
          var savedata = {
            id: {Int64: parseInt(that.fxqdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.myfxcusname, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.fxqdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.fxqdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.fxqdselectnode.data.name = that.myfxcusname
                localStorage.setItem('fxqdtree', JSON.stringify(that.fxqddata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savearearoot () {
      console.log(that.qdareaselect)
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 0) {
          var savedata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.myareaname, Valid: true},
            userid: {Int64: parseInt(-1), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdareaselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdareaselectnode.data.name = that.myareaname
                localStorage.setItem('qdareatree', JSON.stringify(that.qdareadata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savechangeone () {
      console.log(that.qdselect)
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 1) {
          var savedata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edchannelone, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdselectnode.data.name = that.edchannelone
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savefxchannelone () {
      console.log(that.fxqdselect)
      if (that.fxqdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.fxqdselectnode.data.level === 1) {
          var savedata = {
            id: {Int64: parseInt(that.fxqdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edfxchannelone, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(that.fxqdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.fxqdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.fxqdselectnode.data.name = that.edfxchannelone
                localStorage.setItem('fxqdtree', JSON.stringify(that.fxqddata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    saveareaone () {
      console.log(this.fzrone)
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 1) {
          var savedata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edareaone, Valid: true},
            userid: {Int64: parseInt(that.fzrone), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdareaselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                console.log(that.qdareaselectnode.data)
                that.qdareaselectnode.data.name = that.edareaone
                that.qdareaselectnode.data.userid = parseInt(that.fzrone)
                localStorage.setItem('qdareatree', JSON.stringify(that.qdareadata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savechangetwo () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 2) {
          var savedata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edchanneltwo, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdselectnode.data.name = that.edchanneltwo
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savefxchanneltwo () {
      if (that.fxqdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.fxqdselectnode.data.level === 2) {
          var savedata = {
            id: {Int64: parseInt(that.fxqdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edfxchanneltwo, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(that.fxqdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.fxqdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.fxqdselectnode.data.name = that.edfxchanneltwo
                localStorage.setItem('fxqdtree', JSON.stringify(that.fxqddata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    saveareatwo () {
      console.log(that.fzrtwo)
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 2) {
          var savedata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edareatwo, Valid: true},
            userid: {Int64: parseInt(that.fzrtwo), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdareaselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdareaselectnode.data.name = that.edareatwo
                that.qdareaselectnode.data.userid = parseInt(that.fzrtwo)
                localStorage.setItem('ctqdareatree', JSON.stringify(that.qdareadata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    savechangethree () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 3) {
          var savedata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edchannelthree, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdselectnode.data.name = that.edchannelthree
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    saveareathree () {
      console.log(that.fzrthree)
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 3) {
          var savedata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.edareathree, Valid: true},
            userid: {Int64: parseInt(that.fzrthree), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(that.qdareaselect.haschild), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: savedata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('修改成功，调整缓存数据')
                that.qdareaselectnode.data.name = that.edareathree
                that.qdareaselectnode.data.userid = parseInt(that.fzrthree)
                localStorage.setItem('qdareatree', JSON.stringify(that.qdareadata))
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addchannelone () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 0) {
          var upolddata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.qdselect.name, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.channelone, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(1), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.qddata)
                that.qdselectnode.data.haschild = 1
                that.qdselectnode.data.leaf = true
                if (that.qdselectnode.data.Children === null) {
                  that.qdselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.channelone,
                  type: 0,
                  level: 1,
                  haschild: 0,
                  parentid: parseInt(that.qdselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.qdselectnode.data.Children.push(returnadddata)
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                console.log(that.qddata)
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addfxchannelone () {
      if (that.fxqdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.fxqdselectnode.data.level === 0) {
          var upolddata = {
            id: {Int64: parseInt(that.fxqdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.fxqdselect.name, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(that.fxqdselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.fxchannelone, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(1), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.fxqddata)
                that.fxqdselectnode.data.haschild = 1
                that.fxqdselectnode.data.leaf = true
                if (that.fxqdselectnode.data.Children === null) {
                  that.fxqdselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.fxchannelone,
                  type: 0,
                  level: 1,
                  haschild: 0,
                  parentid: parseInt(that.fxqdselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.fxqdselectnode.data.Children.push(returnadddata)
                localStorage.setItem('fxqdtree', JSON.stringify(that.fxqddata))
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addareaone () {
      console.log(that.qdareaselect)
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 0) {
          var upolddata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.qdareaselect.name, Valid: true},
            userid: {Int64: parseInt(that.qdareaselect.userid.Int64), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.areaone, Valid: true},
            userid: {Int64: parseInt(-1), Valid: true},
            level: {Int64: parseInt(1), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级区域信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.qdareadata)
                that.qdareaselectnode.data.haschild = 1
                that.qdareaselectnode.data.leaf = true
                if (that.qdareaselectnode.data.Children === null) {
                  that.qdareaselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.areaone,
                  userid: parseInt(-1),
                  level: parseInt(1),
                  haschild: parseInt(0),
                  parentid: parseInt(that.qdareaselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.qdareaselectnode.data.Children.push(returnadddata)
                localStorage.setItem('qdareatree', JSON.stringify(that.qdareadata))
                console.log(that.qdareadata)
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addchanneltwo () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 1) {
          var upolddata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.qdselect.name, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.channeltwo, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(2), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.qddata)
                that.qdselectnode.data.haschild = 1
                that.qdselectnode.data.leaf = true
                if (that.qdselectnode.data.Children === null) {
                  that.qdselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.channeltwo,
                  type: parseInt(0),
                  level: parseInt(2),
                  haschild: parseInt(0),
                  parentid: parseInt(that.qdselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.qdselectnode.data.Children.push(returnadddata)
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                console.log(that.qddata)
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addfxchanneltwo () {
      if (that.fxqdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.fxqdselectnode.data.level === 1) {
          var upolddata = {
            id: {Int64: parseInt(that.fxqdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.fxqdselect.name, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(that.fxqdselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.fxchanneltwo, Valid: true},
            type: {Int64: parseInt(1), Valid: true},
            level: {Int64: parseInt(2), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.fxqdselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.fxqddata)
                that.fxqdselectnode.data.haschild = 1
                that.fxqdselectnode.data.leaf = true
                if (that.fxqdselectnode.data.Children === null) {
                  that.fxqdselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.fxchanneltwo,
                  type: parseInt(1),
                  level: parseInt(2),
                  haschild: parseInt(0),
                  parentid: parseInt(that.fxqdselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.fxqdselectnode.data.Children.push(returnadddata)
                localStorage.setItem('fxqdtree', JSON.stringify(that.fxqddata))
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addareatwo () {
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 1) {
          var upolddata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.qdareaselect.name, Valid: true},
            userid: {Int64: parseInt(that.qdareaselect.userid.Int64), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.areatwo, Valid: true},
            userid: {Int64: parseInt(-1), Valid: true},
            level: {Int64: parseInt(2), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.qdareadata)
                that.qdareaselectnode.data.haschild = 1
                that.qdareaselectnode.data.leaf = true
                if (that.qdareaselectnode.data.Children === null) {
                  that.qdareaselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.areatwo,
                  userid: parseInt(-1),
                  level: parseInt(2),
                  haschild: parseInt(0),
                  parentid: parseInt(that.qdareaselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.qdareaselectnode.data.Children.push(returnadddata)
                localStorage.setItem('qdareatree', JSON.stringify(that.qdareadata))
                console.log(that.qdareadata)
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addchannelthree () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdselectnode.data.level === 2) {
          var upolddata = {
            id: {Int64: parseInt(that.qdselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.qdselect.name, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(that.qdselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.channelthree, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(3), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.qdselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.qddata)
                that.qdselectnode.data.haschild = 1
                that.qdselectnode.data.leaf = true
                if (that.qdselectnode.data.Children === null) {
                  that.qdselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.channelthree,
                  type: parseInt(0),
                  level: parseInt(3),
                  haschild: parseInt(0),
                  parentid: parseInt(that.qdselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.qdselectnode.data.Children.push(returnadddata)
                localStorage.setItem('ctqdtree', JSON.stringify(that.qddata))
                console.log(that.qddata)
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    addareathree () {
      if (that.qdareaselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请选择渠道右侧编辑按钮'
        })
      } else {
        if (that.qdareaselectnode.data.level === 2) {
          var upolddata = {
            id: {Int64: parseInt(that.qdareaselect.id), Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.qdareaselect.name, Valid: true},
            userid: {Int64: parseInt(that.qdareaselect.userid.Int64), Valid: true},
            level: {Int64: parseInt(that.qdareaselect.level), Valid: true},
            haschild: {Int64: parseInt(1), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.parentid), Valid: true}
          }
          var addnewdata = {
            cusid: {Int64: parseInt(that.khid), Valid: true},
            name: {String: that.areathree, Valid: true},
            type: {Int64: parseInt(0), Valid: true},
            level: {Int64: parseInt(3), Valid: true},
            haschild: {Int64: parseInt(0), Valid: true},
            parentid: {Int64: parseInt(that.qdareaselect.id), Valid: true}
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: upolddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('更新上级渠道信息完毕')
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
          that.$http({
            url: 'https://api.sqnetsoft.cn/control/caaau',
            method: 'post',
            data: addnewdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
                console.log('添加成功，调整缓存数据')
                console.log(that.qdareadata)
                that.qdareaselectnode.data.haschild = 1
                that.qdareaselectnode.data.leaf = true
                if (that.qdareaselectnode.data.Children === null) {
                  that.qdareaselectnode.data.Children = []
                }
                var returnadddata = {
                  id: parseInt(res.data.data),
                  cusid: parseInt(that.khid),
                  name: that.areathree,
                  userid: parseInt(-1),
                  level: parseInt(3),
                  haschild: parseInt(0),
                  parentid: parseInt(that.qdareaselect.id),
                  leaf: 'true',
                  Children: []
                }
                that.qdareaselectnode.data.Children.push(returnadddata)
                localStorage.setItem('qdareatree', JSON.stringify(that.qdareadata))
                console.log(that.qdareadata)
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message({
            type: 'info',
            message: '渠道选择存在错误，请选择正确的渠道'
          })
        }
      }
    },
    removeqdcus (index, data) {
      console.log('移除客户')
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      console.log(curselectdata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/ccdel',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    selectqdcus (index, data) {
      console.log(data[index])
      that.curqdcurdata = data[index]
      that.curqdcusname = that.curqdcurdata.cusname
      var idstr = 'cusid = ' + that.khid + ' and cuserid=' + parseInt(data[index].cusid)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/queryca',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.mycusarea = JSON.parse(res.data.data)
            that.$message({
              type: 'success',
              message: '已读取该客户负责区域'
            })
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    setqdcus (index, data) {},
    removecusarea (index, data) {
      console.log(data[index])
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      console.log(curselectdata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/delca',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savechannelset () {
      console.log(this.curqdcurdata)
      console.log(this.curareadata)
      console.log(this.curfzrdata)
      if (this.curqdcurdata === '' || this.curareadata === '' || this.curfzrdata === '') {
        console.log('数据为空')
      } else {
        console.log('正常数据')
      }
      var insertdata = {
        cuserid: {Int64: parseInt(this.curqdcurdata.cusid), Valid: true},
        cusername: {String: this.curqdcurdata.cusname, Valid: true},
        areaid: {Int64: parseInt(this.curareadata.id), Valid: true},
        areaname: {String: this.curareadata.name, Valid: true},
        userid: {Int64: parseInt(this.curfzrdata.id), Valid: true},
        username: {String: this.curfzrdata.name.String, Valid: true},
        cusid: {Int64: parseInt(that.khid), Valid: true}
      }
      console.log(insertdata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/aauca',
        method: 'post',
        data: insertdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var idstr = 'cusid = ' + that.khid + ' and cuserid=' + parseInt(that.curqdcurdata.cusid)
            that.$http({
              url: 'https://api.sqnetsoft.cn/control/queryca',
              method: 'post',
              data: {
                whereinfo: {'String': idstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                if (res.data.success) {
                  console.log(res.data.data)
                  that.mycusareadata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '已分配区域给了渠道客户'
                  })
                } else {
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      console.log(insertdata)
    },
    querycccus () {
      var qstr = 'ownerid =' + this.khid
      if (this.query_cc_cusname !== null && this.query_cc_cusname !== '') {
        qstr = qstr + " and name like '%" + this.query_cc_cusname + "%' "
      }
      if (this.query_cc_cusno !== null && this.query_cc_cusno !== '') {
        qstr = qstr + " and bl_num like '%" + this.query_cc_cusno + "%'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcus',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.loading = false
            localStorage.setItem('cusinfo', res.data.data)
            that.cus_leftdata = JSON.parse(res.data.data)
            console.log(that.cus_leftdata)
            that.$message({
              type: 'success',
              message: '查询完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addchannelpercent () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请先选择渠道右侧编辑按钮'
        })
      } else {
        console.log(that.qdselect.id)
        console.log(that.channelpercent)
        var cpdata
        if (this.channelpercentid === '') {
          cpdata = {
            channelid: parseInt(that.qdselect.id),
            channelpercent: parseInt(that.channelpercent),
            cusid: parseInt(that.khid)
          }
        } else {
          cpdata = {
            id: {Int64: parseInt(this.channelpercentid), Valid: true},
            channelid: parseInt(that.qdselect.id),
            channelpercent: parseInt(that.channelpercent),
            cusid: parseInt(that.khid)
          }
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/abcp',
          method: 'post',
          data: cpdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '渠道分成保存完毕'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    savecustochannel () {
      if (that.qdselect.length === 0) {
        that.$message({
          type: 'info',
          message: '请先选择渠道右侧编辑按钮'
        })
      } else {
        console.log(this.cus_rightdata)
        console.log(this.cus_leftdata)
        var attlist = []
        for (var index in this.cus_rightdata) {
          var subdata = this.cus_rightdata[index]
          var dataindex = this.cus_leftdata.findIndex(d => d.id === subdata)
          var subdataname = this.cus_leftdata[dataindex]
          console.log(subdata)
          console.log(subdataname)
          var adata
          adata = {
            cid: {Int64: parseInt(that.qdselect.id), Valid: true},
            ccusid: {Int64: parseInt(subdataname.id), Valid: true},
            cusname: {String: subdataname.name, Valid: true},
            cusid: {Int64: parseInt(this.khid), Valid: true}
          }
          attlist.push(adata)
        }
        console.log(attlist)
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/ccpaau',
          method: 'post',
          data: attlist,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              var idstr = 'cusid = ' + that.khid + ' and c_id=' + parseInt(that.qdselect.id)
              that.$http({
                url: 'https://api.sqnetsoft.cn/control/ccquery',
                method: 'post',
                data: {
                  whereinfo: {'String': idstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  if (res.data.success) {
                    console.log(res.data.data)
                    that.myqdcusdatabase = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '已保存至分类'
                    })
                    that.cus_rightdata = []
                  } else {
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    addfxpercent () {
      var cpdata
      if (this.levelpercentid === '') {
        cpdata = {
          level: parseInt(that.fxlevel),
          levelpercent: parseInt(that.fxpercent),
          cusid: parseInt(that.khid)
        }
      } else {
        cpdata = {
          id: {Int64: parseInt(this.levelpercentid), Valid: true},
          level: parseInt(that.fxlevel),
          levelpercent: parseInt(that.fxpercent),
          cusid: parseInt(that.khid)
        }
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/absscp',
        method: 'post',
        data: cpdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '渠道分成保存完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    fxchange () {
      var idstr1 = 'cusid = ' + that.khid + ' and level=' + parseInt(that.fxlevel)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/gbsscp',
        method: 'post',
        data: {
          whereinfo: {'String': idstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            if (res.data.data !== '[]') {
              var data = JSON.parse(res.data.data)
              if (data[0].levelpercent) {
                that.levelpercentid = data[0].id.Int64
                that.fxpercent = data[0].levelpercent
              } else {
                that.fxpercent = ''
              }
            } else {
              that.fxpercent = ''
            }
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/control/ChannelControl.vue